import React from 'react'

import { CLICK_CODE, isNumber } from '@local/utils'

import FlickingArea from '@web/components/FlickingArea/FlickingArea'
import { ConvertedPlaceRecommend } from '@web/pages/v5/home/DdayRecommendPlacesSection'
import { Nullish } from '@web/types'

import { ThumbnailContentPropsItem } from '../../ThumbnailContent'
import { Section, SectionHeader, SectionContent } from '../Section'
import styles from './RecommandPlacesSection.module.scss'
import { SlideImageCard } from './SlideImageCard'

export const ITEMS: ThumbnailContentPropsItem[] = [
  {
    placeName: '더팬런던',
    imageUrl: 'https://picsum.photos/144/192',
    subInfoTexts: ['카페', '리뷰 2,323'],
  },
  {
    placeName: '아아',
    imageUrl: 'https://picsum.photos/144/192',
    subInfoTexts: ['식당', '리뷰 3,323'],
  },
  {
    placeName: '먹고',
    imageUrl: 'https://picsum.photos/144/192',
    subInfoTexts: ['식당', '리뷰 3,323'],
  },
  {
    placeName: '싶다',
    subInfoTexts: ['중식', '리뷰 3,323'],
  },
]

interface Props {
  name: string
  remainBookingDays: Nullish<number>
  recommendPlaces: ConvertedPlaceRecommend[]
}

export default function UIRecommandPlacesSection({ name, remainBookingDays = null, recommendPlaces }: Props) {
  const remainDaysAbs = isNumber(remainBookingDays) ? Math.abs(remainBookingDays) : null
  return (
    <Section className={styles.recommand_places_section}>
      <SectionHeader
        title={
          <div className={styles.tit_wrapper}>
            <em>{name}</em>&nbsp;주변 장소 추천
          </div>
        }
        extra={
          isNumber(remainDaysAbs) ? (
            <span className={styles.date}>{`D-${remainDaysAbs === 0 ? 'Day' : remainDaysAbs}`}</span>
          ) : null
        }
        description="방문 후 많이 찾아본 장소들 추천해드려요."
      />
      <SectionContent>
        <FlickingArea
          className={styles.flicking_area}
          options={{
            cameraTag: 'ul',
            horizontal: true,
            defaultIndex: 0,
          }}
        >
          {recommendPlaces.map((place, index) => {
            return (
              <li className={styles.list_item} key={place.id}>
                <SlideImageCard place={place} clickCode={CLICK_CODE['mynearbyrecommendations.card']} rank={index + 1} />
              </li>
            )
          })}
          {/* <li className={styles.list_item}>
            <FlickingContentMoreButtton name="전체보기" />
          </li> */}
        </FlickingArea>
      </SectionContent>
    </Section>
  )
}
